type ResourceRetrievalError = {
  message: string;
};

const resourceRetrievalError: ResourceRetrievalError = {
  message: "",
};

export type { ResourceRetrievalError };

export { resourceRetrievalError };
